export enum EventDetailsMode {
  create = "create",
  edit = "edit",
  view = "view",
}

export const calendarDropZoneId = "calendar-dropzone";
export const sidebarTodayDropZoneId = "sidebar-dropzone-today";
export const sidebarWeekDropZoneId = "sidebar-dropzone-week";
export const sidebarOverdueDropZoneId = "sidebar-dropzone-overdue";
export const sidebarUpcomingDropZoneId = "sidebar-dropzone-upcoming";
export const sidebarUnplannedDropZoneId = "sidebar-dropzone-unplanned";
export const footerDropZoneId = "footer-dropzone";
